import { PushPin, PushPinSlash } from '@phosphor-icons/react';
import React, { useMemo, useRef } from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Image, Typography } from 'tfc-components';

import empty from 'assets/images/empty_conversation.png';
import Button from 'components/atoms/Button';
import Icon from 'components/atoms/Icon';
import Loading from 'components/atoms/Loading';
import useScrollInfinite from 'hooks/useScrollInfinite';
import { AccountConversationDataType } from 'services/accountConversations/types';
import { ROUTE_PATHS } from 'utils/constants';
import mapModifiers, { groupDataByDate } from 'utils/functions';

interface ConversationListProps {
  handleNewConversation?: () => void;
  dataList: AccountConversationDataType[];
  dataListFavorite: AccountConversationDataType[];
  handleLoadMoreConversation: () => void;
  loadingData?: boolean;
  loadingCreate?: boolean;
  handleToggleFavorite?: (code: string, favorite: boolean) => void;
  codeConversation?: string;
}

const ConversationList: React.FC<ConversationListProps> = ({
  handleNewConversation,
  dataList,
  dataListFavorite,
  handleLoadMoreConversation,
  loadingData,
  loadingCreate,
  handleToggleFavorite,
  codeConversation
}) => {
  const tableRef = useRef(null);
  const { setNode } = useScrollInfinite(handleLoadMoreConversation);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const groupDataByDateData = useMemo(() => {
    if (dataList.length > 0) {
      return groupDataByDate(dataList.filter((item) => !item.favoriteAt));
    }
    return [];
  }, [dataList]);

  const groupDataFavoriteByDateData = useMemo(() => {
    if (dataListFavorite.length > 0) {
      return groupDataByDate(dataListFavorite);
    }
    return [];
  }, [dataListFavorite]);

  return (
    <div className="t-conversationList">
      <Container>
        {groupDataByDateData?.length < 1 ? (
          <div className="t-conversationList_empty">
            <div className="t-conversationList__emptyImg">
              <Image imgSrc={empty} ratio={250 / 200} alt="empty" />
            </div>
            <Typography.Text extendClasses="t-conversationList__emptyText" fontweight="600">
              {t('chatbot.emptyConversation')}
            </Typography.Text>
            <Typography.Text extendClasses="t-conversationList__emptyDesc" fontweight="400" textStyle="center">
              {t('chatbot.startConversation')}
            </Typography.Text>
            <Button
              variant="blue-crayola"
              icon={{
                name: 'whitePlus',
                size: '20',
                align: 'left',
              }}
              onClick={handleNewConversation}
              className="t-conversationList__newConversationBtn"
              isLoading={loadingCreate}
            >
              {t('chatbot.newConversation')}
            </Button>
          </div>
        ) : (
          <div className="t-conversationList__list">
            <div ref={tableRef} className="t-conversationList__listWrap">
              {groupDataFavoriteByDateData.length > 0 && (
                <div className="t-conversationList__itemWrap t-conversationList__item">
                  <Typography.Text extendClasses="t-conversationList__itemTitleList">
                    Đã Ghim
                  </Typography.Text>
                </div>
              )}
              {groupDataFavoriteByDateData.map((item, index) => (
                <div key={`${index.toString()}`}>
                  {/* {item.dataList.length > 0 && (
                    <div className="t-conversationList__item">
                      <Typography.Text extendClasses="t-conversationList__itemTitleList">
                        {item.label || ''}
                      </Typography.Text>
                    </div>
                  )} */}
                  {item.dataList.map((ele) => (
                    <div className="t-conversationList__item" key={ele.code}>
                      <div
                        className="t-conversationList__itemTitle"
                        onClick={() => {
                          navigate(`${ROUTE_PATHS.CHATBOT_WIDGET}?code=${ele.code}&title=${ele.title}`);
                        }}
                      >
                        <div className="t-conversationList__itemTitleWrap">
                          <div className={mapModifiers('t-conversationList__itemTitleIcon', codeConversation === ele.code ? 'active' : '')}>
                            <Icon iconName={codeConversation === ele.code ? 'chatBubbleActive' : 'chatBubble'} size="20x20" />
                          </div>
                          <Typography.Text
                            extendClasses={mapModifiers(
                              't-conversationList__itemTitleText',
                              codeConversation === ele.code ? 'active' : ''
                            )}
                            fontweight="500"
                          >
                            {ele?.title || ''}
                          </Typography.Text>
                        </div>
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            handleToggleFavorite?.(ele.code, !ele.favoriteAt);
                            console.log('handleToggleFavorite', { ele, favorite: !ele.favoriteAt });
                          }}
                        >
                          <PushPinSlash size={20} />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}

              {groupDataByDateData.map((item, index) => (
                <div key={`${index.toString()}`}>
                  {item.dataList.length > 0 && (
                    <div className="t-conversationList__item">
                      <Typography.Text extendClasses="t-conversationList__itemTitleList">
                        {item.label || ''}
                      </Typography.Text>
                    </div>
                  )}
                  {item.dataList.map((ele) => (
                    <div className="t-conversationList__item" key={ele.code}>
                      <div
                        className="t-conversationList__itemTitle"
                        onClick={() => {
                          navigate(`${ROUTE_PATHS.CHATBOT_WIDGET}?code=${ele.code}&title=${ele.title}`);
                        }}
                      >
                        <div className="t-conversationList__itemTitleWrap">
                          <div className={mapModifiers('t-conversationList__itemTitleIcon', codeConversation === ele.code ? 'active' : '')}>
                            <Icon iconName={codeConversation === ele.code ? 'chatBubbleActive' : 'chatBubble'} size="20x20" />
                          </div>
                          <Typography.Text
                            extendClasses={mapModifiers(
                              't-conversationList__itemTitleText',
                              codeConversation === ele.code ? 'active' : ''
                            )}
                            fontweight="500"
                          >
                            {ele?.title || ''}
                          </Typography.Text>
                        </div>
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            handleToggleFavorite?.(ele.code, !ele.favoriteAt);
                            console.log('handleToggleFavorite', { ele, favorite: !ele.favoriteAt });
                          }}
                        >
                          <PushPin size={18} />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
              <div ref={(suggest) => setNode(suggest)} />
              {loadingData && (
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                  <Loading />
                </div>
              )}
            </div>
          </div>
        )}
      </Container>
    </div>
  );
};

export default ConversationList;
